var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgPage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 332,
    viewBox: "0 0 227 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_10507_7217)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8776 13.5674H28.4434V127.665H71.8776V13.5674Z",
    fill: "#FFFAE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.887 13.5674H50.165V127.665H71.887V13.5674Z",
    fill: "#FFE26B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7413 0H33.4014V13.5673H48.7413V0Z",
    fill: "#FFFAE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7417 0H45.0811V13.5673H48.7417V0Z",
    fill: "#FFE26B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1461 12.7703H24.8213V13.5575H73.1461V12.7703Z",
    fill: "#FFE26B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6937 19.4763H37.0137V27.261H40.6937V19.4763Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1654 30.3125C50.1654 30.3903 45.3038 30.4583 39.3092 30.4583C33.3146 30.4583 28.4531 30.3903 28.4531 30.3125C28.4531 30.2348 33.3146 30.1667 39.3092 30.1667C45.3038 30.1667 50.1654 30.2348 50.1654 30.3125Z",
    fill: "#FFE26B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.599 19.4763H58.9189V27.261H62.599V19.4763Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0707 30.3128C72.0707 30.3905 67.2091 30.4586 61.2145 30.4586C55.2199 30.4586 50.3584 30.3905 50.3584 30.3128C50.3584 30.235 55.2199 30.167 61.2145 30.167C67.2091 30.167 72.0707 30.235 72.0707 30.3128Z",
    fill: "#FFFAE6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.599 34.929H58.9189V42.7136H62.599V34.929Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0707 45.7654C72.0707 45.8432 67.2091 45.9112 61.2145 45.9112C55.2199 45.9112 50.3584 45.8432 50.3584 45.7654C50.3584 45.6877 55.2199 45.6196 61.2145 45.6196C67.2091 45.6196 72.0707 45.6877 72.0707 45.7654Z",
    fill: "#FFFAE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.599 50.8384H58.9189V58.6231H62.599V50.8384Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0707 61.6748C72.0707 61.7526 67.2091 61.8206 61.2145 61.8206C55.2199 61.8206 50.3584 61.7526 50.3584 61.6748C50.3584 61.5971 55.2199 61.5291 61.2145 61.5291C67.2091 61.5291 72.0707 61.5971 72.0707 61.6748Z",
    fill: "#FFFAE6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.599 66.7576H58.9189V74.5422H62.599V66.7576Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0707 77.5843C72.0707 77.662 67.2091 77.73 61.2145 77.73C55.2199 77.73 50.3584 77.662 50.3584 77.5843C50.3584 77.5065 55.2199 77.4385 61.2145 77.4385C67.2091 77.4385 72.0707 77.5065 72.0707 77.5843Z",
    fill: "#FFFAE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.599 82.2104H58.9189V89.9951H62.599V82.2104Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0707 93.0469C72.0707 93.1247 67.2091 93.1927 61.2145 93.1927C55.2199 93.1927 50.3584 93.1247 50.3584 93.0469C50.3584 92.9692 55.2199 92.9011 61.2145 92.9011C67.2091 92.9011 72.0707 92.9692 72.0707 93.0469Z",
    fill: "#FFFAE6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.599 97.7312H58.9189V105.516H62.599V97.7312Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.599 113.456H58.9189V121.241H62.599V113.456Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0707 108.568C72.0707 108.645 67.2091 108.713 61.2145 108.713C55.2199 108.713 50.3584 108.645 50.3584 108.568C50.3584 108.49 55.2199 108.422 61.2145 108.422C67.2091 108.422 72.0707 108.49 72.0707 108.568Z",
    fill: "#FFFAE6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6937 35.1621H37.0137V42.9468H40.6937V35.1621Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1654 45.9986C50.1654 46.0763 45.3038 46.1443 39.3092 46.1443C33.3146 46.1443 28.4531 46.0763 28.4531 45.9986C28.4531 45.9208 33.3146 45.8528 39.3092 45.8528C45.3038 45.8528 50.1654 45.9208 50.1654 45.9986Z",
    fill: "#FFE26B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6937 50.8481H37.0137V58.6328H40.6937V50.8481Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1654 61.6748C50.1654 61.7526 45.3038 61.8206 39.3092 61.8206C33.3146 61.8206 28.4531 61.7526 28.4531 61.6748C28.4531 61.5971 33.3146 61.5291 39.3092 61.5291C45.3038 61.5291 50.1654 61.5971 50.1654 61.6748Z",
    fill: "#FFE26B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6937 66.5244H37.0137V74.3091H40.6937V66.5244Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1654 77.3609C50.1654 77.4386 45.3038 77.5066 39.3092 77.5066C33.3146 77.5066 28.4531 77.4386 28.4531 77.3609C28.4531 77.2831 33.3146 77.2151 39.3092 77.2151C45.3038 77.2151 50.1654 77.2831 50.1654 77.3609Z",
    fill: "#FFE26B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6937 82.2104H37.0137V89.9951H40.6937V82.2104Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1654 93.0467C50.1654 93.1244 45.3038 93.1924 39.3092 93.1924C33.3146 93.1924 28.4531 93.1244 28.4531 93.0467C28.4531 92.9689 33.3146 92.9009 39.3092 92.9009C45.3038 92.9009 50.1654 92.9689 50.1654 93.0467Z",
    fill: "#FFE26B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6937 97.8962H37.0137V105.681H40.6937V97.8962Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1654 108.723C50.1654 108.801 45.3038 108.869 39.3092 108.869C33.3146 108.869 28.4531 108.801 28.4531 108.723C28.4531 108.645 33.3146 108.577 39.3092 108.577C45.3038 108.577 50.1654 108.645 50.1654 108.723Z",
    fill: "#FFE26B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6937 113.573H37.0137V121.357H40.6937V113.573Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.092 110.504H7.41797V298.434H106.092V110.504Z",
    fill: "#FFE26B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.091 110.504H59.8291V298.434H106.091V110.504Z",
    fill: "#FFFAE6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9841 128.192H28.1133V149.826H36.9841V128.192Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9841 212.851H28.1133V234.485H36.9841V212.851Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8295 158.31C59.8295 158.495 48.0921 158.65 33.6238 158.65C19.1554 158.65 7.41797 158.495 7.41797 158.31C7.41797 158.125 19.1457 157.97 33.6238 157.97C48.1018 157.97 59.8295 158.125 59.8295 158.31Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9841 170.838H28.1133V192.471H36.9841V170.838Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8295 200.966C59.8295 201.15 48.0921 201.306 33.6238 201.306C19.1554 201.306 7.41797 201.15 7.41797 200.966C7.41797 200.781 19.1457 200.625 33.6238 200.625C48.1018 200.625 59.8295 200.781 59.8295 200.966Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5203 128.192H69.6494V149.826H78.5203V128.192Z",
    fill: "#FFE26B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7732 128.192H88.9023V149.826H97.7732V128.192Z",
    fill: "#FFE26B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5203 169.234H69.6494V190.868H78.5203V169.234Z",
    fill: "#FFE26B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7732 169.234H88.9023V190.868H97.7732V169.234Z",
    fill: "#FFE26B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5203 210.286H69.6494V231.919H78.5203V210.286Z",
    fill: "#FFE26B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7732 210.286H88.9023V231.919H97.7732V210.286Z",
    fill: "#FFE26B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M113.51 105.956H0V110.669H113.51V105.956Z",
    fill: "#FFE26B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106.779 111.116C106.779 111.301 84.7283 111.456 57.525 111.456C30.3217 111.456 8.27051 111.301 8.27051 111.116C8.27051 110.932 30.3217 110.776 57.525 110.776C84.7283 110.776 106.779 110.932 106.779 111.116Z",
    fill: "#FFFAE6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip1_10507_7217)"
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M128.581 42.6423H194.703V252.939H128.581V42.6423Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M128.582 42.6423H161.643V252.355H128.582V42.6423Z",
    fill: "#FFFAE6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M163.809 22H187.153V42.6424H163.809V22Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M163.801 22H169.368V42.6424H163.801V22Z",
    fill: "#FFFAE6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.218 42.6425V41.4402H126.652V42.6425",
    fill: "#FFE26B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M176.063 51.6509H181.657V63.4971H176.063V51.6509Z",
    fill: "#FAFAFA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M161.642 68.1383C161.642 68.2621 169.042 68.3681 178.168 68.3681C187.295 68.3681 194.703 68.2709 194.703 68.1383C194.703 68.0057 187.303 67.9084 178.168 67.9084C169.033 67.9084 161.642 68.0057 161.642 68.1383Z",
    fill: "#FFE26B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M142.711 51.6509H148.305V63.4971H142.711V51.6509Z",
    fill: "#FFE26B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M128.299 68.1383C128.299 68.2621 135.699 68.3681 144.826 68.3681C153.952 68.3681 161.36 68.2709 161.36 68.1383C161.36 68.0057 153.961 67.9084 144.826 67.9084C135.69 67.9084 128.299 68.0057 128.299 68.1383Z",
    fill: "#FFE26B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M142.711 75.1665H148.305V87.0127H142.711V75.1665Z",
    fill: "#FFE26B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M128.299 91.6539C128.299 91.7777 135.699 91.8838 144.826 91.8838C153.952 91.8838 161.36 91.7865 161.36 91.6539C161.36 91.5213 153.961 91.4241 144.826 91.4241C135.69 91.4241 128.299 91.5213 128.299 91.6539Z",
    fill: "#FFE26B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M142.711 99.3892H148.305V111.235H142.711V99.3892Z",
    fill: "#FFE26B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M128.299 115.877C128.299 116 135.699 116.106 144.826 116.106C153.952 116.106 161.36 116.009 161.36 115.877C161.36 115.744 153.961 115.647 144.826 115.647C135.69 115.647 128.299 115.744 128.299 115.877Z",
    fill: "#FFE26B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M142.711 123.612H148.305V135.458H142.711V123.612Z",
    fill: "#FFE26B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M128.299 140.099C128.299 140.223 135.699 140.329 144.826 140.329C153.952 140.329 161.36 140.232 161.36 140.099C161.36 139.967 153.961 139.87 144.826 139.87C135.69 139.87 128.299 139.967 128.299 140.099Z",
    fill: "#FFE26B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M142.711 147.136H148.305V158.983H142.711V147.136Z",
    fill: "#FFE26B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M128.299 163.633C128.299 163.756 135.699 163.863 144.826 163.863C153.952 163.863 161.36 163.765 161.36 163.633C161.36 163.5 153.961 163.403 144.826 163.403C135.69 163.403 128.299 163.5 128.299 163.633Z",
    fill: "#FFE26B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M142.711 170.767H148.305V182.613H142.711V170.767Z",
    fill: "#FFE26B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M142.711 194.698H148.305V206.544H142.711V194.698Z",
    fill: "#FFE26B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M128.299 187.254C128.299 187.378 135.699 187.484 144.826 187.484C153.952 187.484 161.36 187.387 161.36 187.254C161.36 187.122 153.961 187.024 144.826 187.024C135.69 187.024 128.299 187.122 128.299 187.254Z",
    fill: "#FFE26B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M176.063 75.52H181.657V87.3662H176.063V75.52Z",
    fill: "#FAFAFA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M161.642 92.0162C161.642 92.14 169.042 92.2461 178.168 92.2461C187.295 92.2461 194.703 92.1488 194.703 92.0162C194.703 91.8836 187.303 91.7864 178.168 91.7864C169.033 91.7864 161.642 91.8836 161.642 92.0162Z",
    fill: "#FFE26B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M176.063 99.3979H181.657V111.244H176.063V99.3979Z",
    fill: "#FAFAFA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M161.642 115.885C161.642 116.009 169.042 116.115 178.168 116.115C187.295 116.115 194.703 116.018 194.703 115.885C194.703 115.753 187.303 115.656 178.168 115.656C169.033 115.656 161.642 115.753 161.642 115.885Z",
    fill: "#FFE26B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M176.063 123.267H181.657V135.113H176.063V123.267Z",
    fill: "#FAFAFA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M161.642 139.755C161.642 139.878 169.042 139.984 178.168 139.984C187.295 139.984 194.703 139.887 194.703 139.755C194.703 139.622 187.303 139.525 178.168 139.525C169.033 139.525 161.642 139.622 161.642 139.755Z",
    fill: "#FFE26B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M176.063 147.136H181.657V158.983H176.063V147.136Z",
    fill: "#FAFAFA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M161.642 163.633C161.642 163.756 169.042 163.863 178.168 163.863C187.295 163.863 194.703 163.765 194.703 163.633C194.703 163.5 187.303 163.403 178.168 163.403C169.033 163.403 161.642 163.5 161.642 163.633Z",
    fill: "#FFE26B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M176.063 171.014H181.657V182.861H176.063V171.014Z",
    fill: "#FAFAFA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M161.642 187.502C161.642 187.626 169.042 187.732 178.168 187.732C187.295 187.732 194.703 187.634 194.703 187.502C194.703 187.369 187.303 187.272 178.168 187.272C169.033 187.272 161.642 187.369 161.642 187.502Z",
    fill: "#FFE26B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M176.063 194.884H181.657V206.73H176.063V194.884Z",
    fill: "#FAFAFA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M121.134 299.333H218.432L218.863 145.023H121.566L121.134 299.333Z",
    fill: "#FFFAE6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M121.566 145.023H170.21V299.342H121.566V145.023Z",
    fill: "#FFE26B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M173.39 114.639H207.746V145.015H173.39V114.639Z",
    fill: "#FFFAE6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M173.39 114.639H181.583V145.015H173.39V114.639Z",
    fill: "#FFE26B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M118.712 143.247H226.968V145.015H118.712V143.247Z",
    fill: "#FFE26B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M191.414 158.266H199.65V175.691H191.414V158.266Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M170.21 182.533C170.21 182.719 181.098 182.869 194.532 182.869C207.966 182.869 218.854 182.719 218.854 182.533C218.854 182.348 207.966 182.198 194.532 182.198C181.098 182.198 170.21 182.348 170.21 182.533Z",
    fill: "#FFE26B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M142.346 158.266H150.583V175.691H142.346V158.266Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M121.143 182.533C121.143 182.719 132.031 182.869 145.465 182.869C158.899 182.869 169.787 182.719 169.787 182.533C169.787 182.348 158.899 182.198 145.465 182.198C132.031 182.198 121.143 182.348 121.143 182.533Z",
    fill: "#FFFAE6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M142.346 192.868H150.583V210.292H142.346V192.868Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M121.143 217.135C121.143 217.321 132.031 217.471 145.465 217.471C158.899 217.471 169.787 217.321 169.787 217.135C169.787 216.949 158.899 216.799 145.465 216.799C132.031 216.799 121.143 216.949 121.143 217.135Z",
    fill: "#FFFAE6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M142.346 228.513H150.583V245.937H142.346V228.513Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M121.143 252.78C121.143 252.965 132.031 253.116 145.465 253.116C158.899 253.116 169.787 252.965 169.787 252.78C169.787 252.594 158.899 252.444 145.465 252.444C132.031 252.444 121.143 252.594 121.143 252.78Z",
    fill: "#FFFAE6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M142.346 264.157H150.583V281.582H142.346V264.157Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M121.143 288.424C121.143 288.61 132.031 288.76 145.465 288.76C158.899 288.76 169.787 288.61 169.787 288.424C169.787 288.239 158.899 288.088 145.465 288.088C132.031 288.088 121.143 288.239 121.143 288.424Z",
    fill: "#FFFAE6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M191.414 193.398H199.65V210.823H191.414V193.398Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M170.21 217.665C170.21 217.851 181.098 218.001 194.532 218.001C207.966 218.001 218.854 217.851 218.854 217.665C218.854 217.48 207.966 217.329 194.532 217.329C181.098 217.329 170.21 217.48 170.21 217.665Z",
    fill: "#FFE26B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M191.414 228.53H199.65V245.955H191.414V228.53Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M170.21 252.797C170.21 252.983 181.098 253.133 194.532 253.133C207.966 253.133 218.854 252.983 218.854 252.797C218.854 252.612 207.966 252.461 194.532 252.461C181.098 252.461 170.21 252.612 170.21 252.797Z",
    fill: "#FFE26B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M191.414 263.653H199.65V281.078H191.414V263.653Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M170.21 287.92C170.21 288.106 181.098 288.256 194.532 288.256C207.966 288.256 218.854 288.106 218.854 287.92C218.854 287.735 207.966 287.584 194.532 287.584C181.098 287.584 170.21 287.735 170.21 287.92Z",
    fill: "#FFE26B"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9544 310.296C46.2216 311.141 48.9953 313.014 50.8784 314.026C52.8822 315.111 56.129 317.384 59.7747 319.387C66.0828 322.838 73.7174 327.356 74.6914 325.157C74.6914 325.157 64.3851 319.415 58.5502 315.695C52.7152 311.966 46.9544 310.306 46.9544 310.306V310.296Z",
    fill: "#45494E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M79.117 130.424C79.117 130.424 79.7849 125.155 79.9982 123.568C80.963 118.559 82.9946 116.713 81.7144 115.303C80.4342 113.893 79.0613 115.507 78.1244 118.012C77.7997 118.874 77.4657 119.728 77.1596 120.47C76.5659 119.728 75.9908 118.921 75.5733 118.141C74.5343 115.089 73.384 110.655 72.9944 109.514C72.6048 108.373 71.8627 107.483 70.6475 108.002C69.2189 108.605 70.1836 111.407 71.1391 115.108C72.0111 118.448 72.1224 118.884 72.1224 118.884C72.1224 118.884 68.82 110.683 68.1892 109.347C67.2244 107.297 65.5082 108.169 65.3969 109.542C65.267 111.193 68.4396 119.394 68.7365 120.164C68.7365 120.164 68.7365 120.164 68.7272 120.164C68.3932 119.653 65.7309 115.563 64.8125 113.679C63.8292 111.676 63.1798 111.175 62.4284 111.407C61.677 111.639 61.2224 112.733 62.6232 115.665C64.024 118.596 65.8793 121.945 65.8793 121.945C65.8793 121.945 62.3727 117.511 61.4544 116.258C60.3133 114.709 58.6899 115.303 59.1167 116.639C59.5619 118.03 63.588 123.661 63.9869 124.32L70.3228 133.986L71.9926 137.613L80.5177 133.819L79.1077 130.414L79.117 130.424Z",
    fill: "#FCCAA4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6793 321.011C88.8666 324.211 85.7775 324.276 84.0149 325.863C81.5845 328.052 81.5381 331.642 81.5381 331.642L114.98 331.605L114.155 314.118L97.6051 314.313C96.5476 316.855 94.8871 319.165 92.6793 321.011Z",
    fill: "#060505"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M116.817 137.131C122.68 136.806 128.125 129.023 128.125 129.023C126.966 129.042 126.446 127.863 126.594 125.637C126.632 125.136 126.706 124.385 126.799 123.503C125.75 123.401 125.092 123.318 125.092 123.318C126.752 115.572 129.702 100.609 129.702 100.609C124.285 98.8184 120.695 93.3638 120.695 93.3638C119.526 94.5604 117.336 95.6458 115.008 96.7033C113.533 97.362 112.216 97.8815 111.316 98.2154C110.314 102.557 110.685 109.895 110.898 112.01C111.103 114.06 112.438 120.108 118.849 120.628C120.054 120.72 121.14 120.702 122.114 120.591C122.114 120.591 117.902 122.26 114.09 122.353C113.756 124.505 113.329 126.583 112.847 127.335C111.706 129.125 110.305 129.83 110.305 129.83C109.739 132.567 110.973 137.455 116.826 137.131H116.817ZM117.578 112.084C118.849 111.908 121.557 110.999 122.355 111.935C122.485 112.093 122.568 112.297 122.578 112.557C122.624 113.744 121.121 115.6 119.451 115.897C118.459 116.073 117.364 115.683 116.576 115.062C116.047 114.644 115.657 114.134 115.528 113.605C115.212 112.307 117.374 112.112 117.578 112.075V112.084Z",
    fill: "#FCCAA4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M122.104 120.581C121.13 120.692 120.045 120.72 118.839 120.618C112.438 120.099 111.102 114.05 110.889 112C110.675 109.885 110.314 102.547 111.306 98.2061C112.206 97.8721 113.533 97.3526 114.998 96.694C117.327 95.6457 119.516 94.5604 120.685 93.3544C120.685 93.3544 124.275 98.809 129.692 100.599C129.692 100.599 126.742 115.572 125.082 123.308C125.082 123.308 125.741 123.392 126.789 123.494C129.08 123.717 133.245 124.023 136.418 123.772C136.418 123.772 136.743 114.023 137.429 110.581C138.496 105.228 140.796 97.7886 134.609 92.0093C130.657 88.3172 123.041 87.2133 117.716 88.5399C112.392 89.8664 110.536 96.5363 110.072 98.6328C108.449 105.479 106.186 120.396 106.186 120.396C108.625 120.804 112.085 121.147 114.201 121.342C114.154 121.676 114.108 122.01 114.052 122.344C117.874 122.242 122.076 120.581 122.076 120.581H122.104Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M139.387 168.773C139.544 170.471 139.665 171.825 139.674 171.992C139.582 170.897 139.479 169.821 139.387 168.773Z",
    fill: "#FF4F00"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0744 186.881C96.0744 186.881 96.0466 186.881 96.0373 186.89C96.0373 186.89 91.4732 207.382 89.8776 239.767C76.4266 267.995 62.6787 299.146 62.6787 299.146L67.7344 302.254L80.7588 310.25L82.0668 311.048C82.0668 311.048 85.5177 304.879 90.6291 295.677C90.7496 297.198 90.8702 298.729 91.0094 300.268L90.6569 295.621L95.5827 285.797L105.388 269.517L91.3062 303.478C91.6495 307.059 92.0391 310.695 92.4751 314.369L97.5865 314.304L114.136 314.109L117.531 314.072C117.531 314.072 117.058 270.611 117.605 246.631C121.993 238.542 125.917 231.204 128.765 225.713C137.392 209.061 140.741 196.278 140.825 189.005C140.825 188.996 140.825 188.987 140.825 188.977C140.825 188.875 140.825 188.783 140.825 188.68C140.825 188.68 140.825 188.68 140.806 188.68C140.055 188.523 108.839 182.103 96.0466 186.881H96.0744Z",
    fill: "#00CCCC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2652 306.345C62.4841 307.467 59.0425 307.291 56.3801 306.929C53.9218 306.586 50.7863 306.641 48.9681 308.2C48.4115 308.682 46.9551 310.306 46.9551 310.306C46.9551 310.306 52.7158 311.976 58.5508 315.695C64.3858 319.425 74.6921 325.158 74.6921 325.158C75.4156 323.627 78.6068 315.677 80.7775 310.25L67.7532 302.254C67.0203 303.645 65.8886 305.324 64.2652 306.345Z",
    fill: "#060505"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M116.575 115.071C117.364 115.693 118.458 116.082 119.451 115.906C121.121 115.609 122.624 113.754 122.577 112.566C122.568 112.297 122.484 112.093 122.355 111.945C120.713 112.205 118.022 112.956 116.575 115.08V115.071Z",
    fill: "#FF4F00"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M115.526 113.624C115.656 114.143 116.046 114.663 116.575 115.08C118.022 112.956 120.712 112.204 122.354 111.945C121.556 111.008 118.857 111.917 117.577 112.093C117.373 112.13 115.211 112.325 115.526 113.624Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4242 166.241L94.4316 163.012L95.5541 169.942L96.1107 169.488L97.0569 168.699C96.2962 168.059 95.7304 167.205 95.4335 166.241H95.4242Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M139.684 167.456C140.649 164.868 141.772 161.296 142.885 156.546C145.76 144.274 148.571 138.411 146.679 133.476C144.786 128.54 140.324 128.132 133.961 128.819L128.135 129.023C128.135 129.023 122.69 136.806 116.827 137.131C110.964 137.455 109.739 132.557 110.305 129.83L103.71 131.054C101.001 131.444 95.6391 131.416 93.7745 136.064C91.9099 140.711 89.7948 151.083 89.7948 151.083L83.1528 132.659L80.5368 133.819L72.0116 137.613L70.7871 138.16L81.0563 167.01C82.2066 170.257 85.3792 172.335 88.8208 172.094L90.101 172.01C92.3644 171.853 94.4702 170.944 96.1122 169.478L95.5556 169.933L94.4331 163.003L93.6817 160.563L92.5592 157.632L90.8616 153.42C90.8616 153.42 95.166 153.68 96.3255 154.032C97.4851 154.376 98.1901 155.916 100.63 159.895L101.075 160.517L101.186 160.665L102.448 162.437C102.726 162.827 103.199 163.031 103.673 162.966L105.806 162.678L105.277 170.61L102.866 170.786C101.65 170.879 100.454 170.656 99.359 170.164C98.0603 176.862 96.6038 184.358 96.1029 186.872C108.895 182.094 140.102 188.514 140.862 188.671C140.64 183.513 140.185 177.493 139.703 171.992L133.367 173.365C133.367 173.365 137.504 172.261 139.369 168.253C139.499 167.994 139.61 167.715 139.712 167.437L139.684 167.456Z",
    fill: "#FF4F00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M100.74 137.891C99.766 140.229 98.7642 142.724 98.1334 144.617C95.8328 151.435 99.2651 155.777 101.64 158.263C101.64 158.263 101.38 159.589 101.176 160.675",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M133.338 173.384L139.674 172.011C139.674 172.011 139.674 172.011 139.674 171.992C139.655 171.825 139.535 170.471 139.386 168.773C139.368 168.606 139.358 168.439 139.34 168.272C137.475 172.28 133.338 173.384 133.338 173.384Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5919 285.816L90.666 295.63L91.0185 300.278L91.269 303.589L91.3154 303.497L105.397 269.526L95.5919 285.816Z",
    fill: "#060505"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5812 118.318C73.3289 118.559 71.0839 119.097 68.9132 120.09C66.6868 121.11 65.2026 122.724 64.4883 123.633",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3796 122.334C76.3796 122.334 73.0771 124.514 73.0215 127.956",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M117.623 246.641C110.174 263.849 96.751 281.966 90.6377 295.686",
    stroke: "#060505",
    strokeWidth: 0.343234,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9199 243.913C95.4061 227.03 106.742 206.844 111.334 198.811",
    stroke: "#060505",
    strokeWidth: 0.343234,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M118.699 102.557C117.846 105.813 115.388 106.527 114.989 107.779C114.59 109.032 117.132 110.117 117.132 110.117",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M123.861 105.508C123.965 104.907 123.77 104.372 123.427 104.313C123.084 104.254 122.721 104.693 122.618 105.294C122.515 105.895 122.709 106.43 123.052 106.489C123.396 106.548 123.758 106.109 123.861 105.508Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M116.644 104.221C116.747 103.62 116.553 103.085 116.209 103.026C115.866 102.967 115.504 103.406 115.4 104.007C115.297 104.608 115.491 105.143 115.835 105.202C116.178 105.261 116.54 104.822 116.644 104.221Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M126.149 102.056C126.149 102.056 124.497 100.451 122.188 101.314",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 100.572C118.172 100.572 116.363 99.0225 114.238 100.256",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M102.846 170.795L105.258 170.619L105.786 162.688L103.653 162.975C103.18 163.04 102.707 162.836 102.428 162.447L101.167 160.675L101.055 160.526L100.61 159.905C98.161 155.916 97.4653 154.385 96.3057 154.042C95.1461 153.699 90.8418 153.43 90.8418 153.43L92.5394 157.641L93.6619 160.573L94.4133 163.012L95.4059 166.241C95.7027 167.196 96.2686 168.05 97.0293 168.699C97.1313 168.782 97.2334 168.866 97.3447 168.94L98.0497 169.45C98.4486 169.738 98.866 169.979 99.3113 170.174C100.406 170.666 101.612 170.879 102.818 170.795H102.846Z",
    fill: "#FCCAA4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0739 159.858C96.0739 159.858 94.1815 156.556 92.0293 156.278",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1152 158.986C98.1152 158.986 96.0558 155.684 94.989 155.452C93.5325 155.136 91.3711 154.7 91.3711 154.7",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M139.34 168.272C137.874 171.324 134.915 173.42 131.501 173.736L104.887 176.25L105.889 161.296L125.676 159.951C126.909 159.867 127.948 158.986 128.236 157.78L132.206 141.082",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2091 162.103C94.1349 161.741 91.6302 154.867 89.7842 151.083",
    stroke: "black",
    strokeWidth: 0.371063,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10507_7217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.833,
    height: 297.956,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10507_7217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.968,
    height: 277.333,
    fill: "white",
    transform: "matrix(-1 0 0 1 226.968 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPage2);
export default __webpack_public_path__ + "static/media/imgPage2.e6a708b2d094306f9f70676d0c7887ac.svg";
export { ForwardRef as ReactComponent };